module.exports = __webpack_public_path__ + "img/cover6.3ad6271d.png";